// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;My flesh also faints for you,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;as in a dry and thirsty land where there is no water.<br> </p> </div></div>";
// Exports
module.exports = code;